module.exports = __webpack_public_path__ + "img/fachadaalex2.92b4ee33.png";